/**
 * Created by mykurisu on 2017/6/23.
 * className={(ended ? !ended : has_more) ? 'liveroom-list-area-nomargin' : 'liveroom-list-area'}
 */
import React from 'react'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import axios from 'axios'
import {LoadMore} from 'react-weui'
import {WKCurrencyItem} from '../wk'
import '../../styles/liveroom/LiveroomListArea.css'
import IconCreate from '../../images/liveroom/icon-create.png'

class LiveroomChannelListArea extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            offset: this.props.next_offset,
            ended: false
        };
        this.handleLoadMore = this.handleLoadMore.bind(this);
    }

    handleLoadMore() {
        let params = {
            limit: 10,
        };
        params.offset = this.state.offset;

        this.setState({
            loading: true
        });

        const {liveroom_id} = this.props;

        axios.get(`/api/liveroom/${liveroom_id}/channel_list_n`, {params: params}).then((response) => {
            const {next_offset, has_more, channels} = response.data.data;
            if (response.data.code === 0) {
                this.setState({
                    loading: false,
                    offset: next_offset,
                    ended: !has_more
                });

                this.props.dispatch({
                    type: 'LIVEROOM_CHANNELS_APPEND',
                    payload: {
                        channels: channels
                    }
                })
            }
        });
    }

    renderLoadStyle() {
        const {has_more} = this.props.channel;
        const {ended, loading} = this.state;
        if (has_more) {
            if (!ended) {
                if (!loading) {
                    return (
                        <div className="weui-padding text-center liveroom-loadmore-container" onClick={this.handleLoadMore}>
                            <a className="block text-center liveroom-loadmore">
                                查看更多
                            </a>
                        </div>
                    )
                } else {
                    return (
                        <LoadMore loading className="liveroom-page-container_loading">正在加载</LoadMore>
                    )
                }
            } else {
                return true
            }
        } else {
            return true
        }
    }

    render() {
        const {channelList, channel, role} = this.props;
        return (
            <div className="liveroom-page-container" style={{marginTop: '10px'}}>
                {role.is_manager ?
                    <div className="liveroom-page-titlebar">
                        <span className="liveroom-page-titlebar-title" onClick={() => location.assign(`/liveroom/${this.props.liveroom_id}/edit/channel`)}>专栏（{channel.total_count}）</span>
                        <img className="liveroom-page-create liveroom-page-create__channel" src={IconCreate} onClick={() => location.assign(`/liveroom/${this.props.liveroom_id}/channel/create`)}/>
                    </div>
                    :
                    <div className="liveroom-page-titlebar">
                        <span className="liveroom-page-titlebar-title">专栏（{channel.total_count}）</span>
                    </div>
                }
                <div>
                    {
                        channel.channels.length === 0
                            ?
                            <div className="liveroom-channel-list-nothing">
                                一个专栏包含多个课程。<br />
                                用户更愿意购买专栏，一次收听多个课程。
                            </div>
                            :
                            <div>
                                {channelList.map((item) => <WKCurrencyItem liveroomId={this.props.liveroom_id} isShowDelMoney={true} key={item.id} content={item} type={'channel'} role={role} relayShow={role.is_manager}/>)}
                            </div>
                    }
                </div>
                {this.renderLoadStyle()}
            </div>
        )
    }

}

export default connect(state => ({
    channel: state.liveroom.channel,
    liveroom_id: state.liveroom.liveroom.id,
    channelList: state.liveroom.channelList,
    next_offset: state.liveroom.channel.next_offset,
    role: state.liveroom.role,
}))(LiveroomChannelListArea)


// WEBPACK FOOTER //
// ./src/components/liveroom/LiveroomChannelListArea.js